import React from 'react';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {createForm, fieldStyles} from 'core/form/createForm';
import {FieldText, FormProps, ClosedContentProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {formatInterval} from "core/common/utils/dateUtils";
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import Form from "core/form/form";
import {DocumentTemplate} from "core/document/documentDomain";
import {observer} from "mobx-react";
import {DefinitionType, FIELDDEFDISPLAYTYPE} from "core/form/form";
import MdField, {VALUESOURCETYPE} from "core/metamodel/mdField";
import {ClosedFormBlock, ClosedFormField} from "core/form/closedForm";
import {Validate} from "core/form/validate";



@observer
class DocumentTemplateForm extends React.Component<FormProps<DocumentTemplate, DocumentTemplate>, undefined> {

  render() {


    let {dataObject, rootObject, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {comment, validFrom, validTo, profitCenter, language, useSaxonForXslt, computations, documentNameExpression, invoiceTypeIds} = fields;

    let openContent = (
      <div>


        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...profitCenter.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...language.props} />
          </div>
        </div>

        <div className="row">

          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...invoiceTypeIds.props} multi floatingLabelStyle={{top: 15}}/>
            <Validate field={invoiceTypeIds} value={invoiceTypeIds.props.value}/>
          </div>

          <div className="col-xs-8 col-sm-6">
            <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value}
                                onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...documentNameExpression.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-10">
            <StyledSelect {...fieldStyles.small.styledSelect} {...computations.props} multi floatingLabelStyle={{top: 15}} />
          </div>
          <div className="fx col-xs-4 col-sm-2">
            <MdCheckbox {...useSaxonForXslt.props} />
          </div>

        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={2}  />
          </div>
        </div>

      </div>
    );


    return (
      <BlockComp noPadding >
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<DocumentTemplate>) => (
  <div>
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} singleColumn>
      <ClosedFormField label={fields.templateIndex.textLabel} value={dataObject.templateIndex}/>
      <ClosedFormField label={fields.language.textLabel} value={dataObject.language}/>
      <ClosedFormField label={fields.profitCenter.textLabel} value={dataObject.profitCenter}/>
      <ClosedFormField label={fields.invoiceTypeIds.textLabel} value={dataObject.invoiceTypeIds}/>
      <ClosedFormField label={fields.useSaxonForXslt.textLabel} value={dataObject.useSaxonForXslt}/>
      <ClosedFormField label={fields.validFrom.textLabel} value={formatInterval(dataObject.validFrom, dataObject.validTo)} mdField={fields.validFrom.mdField}/>
      <ClosedFormField label={fields.documentNameExpression.textLabel} value={dataObject.documentNameExpression}/>
      <ClosedFormField label={fields.computations.textLabel} value={dataObject.computations}/>
      <ClosedFormField label={fields.comment.textLabel} value={dataObject.comment}/>
    </ClosedFormBlock>
  </div>
);

const definition: DefinitionType = {
  formName: 'DocumentTemplateForm',
  fields: [{
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }, {
    name: 'profitCenter'
  }, {
    name: 'invoiceTypeIds',
    omitNullOption: true,
  }, {
    name: 'language'
  }, {
    name: 'computations',
    mdField: new MdField({label: 'Computed properties', valueSource: 'DOCUMENTCOMPUTATION', valueSourceType: VALUESOURCETYPE.LOCAL})
  }, {
    name: 'documentNameExpression'
  }, {
    name: 'templateIndex'
  }, {
    name: 'useSaxonForXslt',
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }]
};

export default createForm(definition, ClosedContent)(DocumentTemplateForm);




// WEBPACK FOOTER //
// ./src/core/document/component/documentTemplateForm.tsx